import axios from 'axios'
import { ApiUrl, Redirect } from '../services/url'
import { GetTokenWithExpiry } from '../utilities/tokenSetting'
export const WebApi = {
  services: async () => {
    let Query = {
      query: `
         query{
          services{
            icon
          title
          slug
          _id
        children{
          icon
         title
         slug
    }
  }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  service: async (slug) => {
    let Query = {
      query: `
         query{
          service(slug: ${JSON.stringify(slug)}){
            title
            slug
            icon
             children {
              _id
             title
             slug
             icon
    }
  }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  lawyers: async (data) => {
    let Query = {
      query: `
              query{
                  searchLawyers(input: {
                       services: ${JSON.stringify(data.services)}
                  }, page:1, limit: 100){
                      lawyers {
                         _id
                         fname
                         lname
                         coordinates
                         mobile
                         avatar
                         city {
                            title
                         }
                    }
                }
           }
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  lawyer: async (id) => {
    let Query = {
      query: `
            query{
                lawyer(id: ${JSON.stringify(id)}){
                isBought
                _id
                title
                fname
                lname
                avatar
                coordinates
                likes
                mobile
                city {
                    title
                 }
                services {
                  title
                }
                description
                resumeText
                resume
  }
   
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  storeComment: async (data) => {
    let Query = {
      query: `
            mutation{
            commentStore(input: {
                  lawyer: ${JSON.stringify(data.lawyer)},
                  comment: ${JSON.stringify(data.comment)}
              }){
                    _id
                writer {
                  fname
                  lname
                  mobile
      }
  }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  lastComment: async (id) => {
    let Query = {
      query: `
            query{
              lastComment(userId: ${JSON.stringify(id)}){
                createdAt
                comment
                writer {
                fname
                lname
                avatar
            }
       }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  comments: async (id, page) => {
    let Query = {
      query: `
           query{
  comments(lawyer: ${JSON.stringify(id)},page: ${page}, limit: 10){
    totalPages
    currentPage
    comments{
      createdAt
      comment
      writer {
          fname
          lname
          avatar
      }
    }
  }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },

  likeDislike: async (id) => {
    let Query = {
      query: `
           mutation{
             likeLawyer(lawyer: ${JSON.stringify(id)}){
                message
          }
    }
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  provinces: async () => {
    let Query = {
      query: `
           query{
            provinces{
              _id
              title
              cities {
               _id
               title
    }
  }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  cities: async (id) => {
    let Query = {
      query: `
           query{
  cities(provinceId:${JSON.stringify(id)}){
    _id
    title
  }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  profile: async () => {
    let Query = {
      query: `
         query{
    user{
        avatar
        mobile
        fname
        lname
        phone
        avatar
        postcode
        province{
            title
            _id
        }
        city{
          _id
          title
        }
        address
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  updateProfile: async (data) => {
    let Data = {
      query: `
          mutation($avatar: Upload){
  updateUserProfile(input:{
        fname:${JSON.stringify(data.fname)},
        lname:${JSON.stringify(data.lname)},
        phone:${JSON.stringify(data.phone)},
        mobile:${JSON.stringify(data.mobile)},
        city:${JSON.stringify(data.city)},
        province:${JSON.stringify(data.province)},
        postcode:${JSON.stringify(data.postcode)},
        avatar:$avatar
  })
  {
    changedMobile
    user{
      _id
    fname
    lname
    mobile
    avatar
    city {
        _id
        title
    }
    province {
        _id
        title
    }
  }
  }
}
      `,
      variables: {
        avatar: 'none',
      },
    }
    let formdata

    if (typeof data.avatar != 'object') {
      formdata = JSON.stringify(Data)
    } else {
      formdata = new FormData()
      let map = {
        0: ['variables.avatar'],
      }
      formdata.append('operations', JSON.stringify(Data))
      formdata.append('map', JSON.stringify(map))
      formdata.append(0, data.avatar)
    }
    return await axios.post(`${ApiUrl}`, formdata, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
        'Content-Type': 'application/json',
      },
    })
  },

  searchLawyers: async (typesWork, coordinates, distance) => {
    let Query = {
      query: `
              query{
                  searchLawyers(input: {
                       services:${JSON.stringify(typesWork)},
                       coordinates:${JSON.stringify(coordinates)}
                       distance:${distance}
                  }, page:1, limit: 100){
                      lawyers {
                         _id
                         fname
                         lname
                         services{
                           _id
                         }
                         coordinates
                         avatar
                         mobile
                    }
                }
           }
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },

  searchAddress: async (value) => {
    let Query = {
      query: `
            query {
        addressSearch(address: ${JSON.stringify(value)}){
        address,
        coordinates
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  typeWork: async () => {
    let Query = {
      query: `
             query {
    servicesOnMap{
        _id
        title
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  library: async (page, valueSearch) => {
    let Query = {
      query: `
            query {
    libraries(s: ${JSON.stringify(valueSearch)} ,page: ${page}, limit: 10) {
        currentPage
        totalPages
        libraries {
            _id
            title
            image
            titleContent
            author
        }
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  book: async (id) => {
    let Query = {
      query: `
      query {
    library(id: ${JSON.stringify(id)}) {
         category {
            title
        }
         _id
         title
         image
         author
         publisher
         titleContent
         content
        rate
        file {
             filename
             size
             type
         }
        wasLike
        countLike
        }
    }
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  likeDislikeLibrary: async (id) => {
    let Query = {
      query: `
          mutation {
         likeLibrary(id: ${JSON.stringify(id)}) {
            wasLike
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  rateLibrary: async (id, rateBook) => {
    let Query = {
      query: `
         mutation {
    rateLibrary(id: ${JSON.stringify(id)}, rate: ${JSON.stringify(rateBook)}){
        rate
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  orderConsulting: async (serviceId, device) => {
    let Query = {
      query: `
       mutation {
    orderConsultingService(
        id: ${JSON.stringify(serviceId)}, 
        device:2,
        redirect: ${JSON.stringify(Redirect + '/callbackConsulting')}
    ){
        url
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  consultingList: async (page) => {
    let Query = {
      query: `
      query {
        consultingList(page:${page}, limit: 10){
       totalPages
       currentPage
       consultings{
           _id
           lawyer {
               title
               _id
               fname
               lname
               mobile
               avatar
           }
           consultingService{
             service{
               title
             }
           }
             reserveTime{ 
              date 
              time
           }
           status
          }
        }  
      }
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  calendarLawyer: async (id) => {
    let Query = {
      query: `
     query {
    workDays(id: ${JSON.stringify(id)}){
        businessDays{
           day
           from
            to
        }
        holidayDays {
            date
            time
        }
        reservedTime{
            date 
            time
        }
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  consultingServiceList: async (id, type, typeWork) => {
    let Query = {
      query: `
    query {
    consultingServiceList(
        lawyer: ${JSON.stringify(id)},
        service:${JSON.stringify(typeWork)},
        type: ${JSON.stringify(type)}
    ){
        _id
        time
        price
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  singleConsulting: async (id) => {
    let Query = {
      query: `
        query {
    consulting(id: ${JSON.stringify(id)}){
       _id
        lawyer {
            _id
            title
            fname
            lname
            mobile
            avatar
            likes
            coordinates
            address
        }
        reserveTime{ 
            date 
            time
        }
        amount
        ref
        trackingCode
        minutes
        status
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  calendarDuration: async () => {
    let Query = {
      query: `
       query {
    calenderDuration{
        time
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  consultingSetTime: async (id, data, time) => {
    let Query = {
      query: `
      mutation {
    consultingSetTime(id: ${JSON.stringify(id)}, 
        date: ${JSON.stringify(data)},
        time: ${JSON.stringify(time)}){
        _id
        lawyer {
            title
            _id
            mobile
            avatar
        }
        reserveTime{ 
            date 
            time
        }
        amount
        ref
        trackingCode
        minutes
        status
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  documentsList: async () => {
    let Query = {
      query: `
     query {
    documentList(page: 1, limit: 50){
        currentPage
        totalPages
        documents {
             lawyer{
                title
                fname
                lname
            }
            _id
            title
            number
            finishedAt
            payments{
                amount
                status
                afterSessionCourt
                afterSessionOnlin
            }
            status
        }
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  document: async (id) => {
    let Query = {
      query: `
    query {
    document(id: ${JSON.stringify(id)}){
        _id
        lawyer{
          _id
          title
            fname
                lname
                isBought
                mobile
                avatar 
                description
                resumeText
                resume   
                likes   
       }
        number
        description
        countSessionCourt
        countSessionOnline
        payments{
            _id
            amount
            status
            afterSessionCourt
            afterSessionOnlin
        }
        percent
        finishedAt
        status
        createdAt
        updatedAt
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  transactions: async (id) => {
    let Query = {
      query: `
   query {
    documentPaymentList(page: 1, limit: 50){
        totalPages
        currentPage
        documentPayments {
            _id
            document {
                _id
                title
                number
            }
            lawyer {
                title
                fname
                lname
            }
            amount
            status
            afterSessionCourt
            afterSessionOnlin
            ref
            ip
            device
            createdAt
            updatedAt
        }
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  productList: async (page, isDownloadable) => {
    let Query = {
      query: `
   query {
    productList(page: ${page}, limit: 10, isDownloadable: ${isDownloadable}){
        currentPage
        totalPages
        list {
            _id
            category {
                title
                slug
            }
            title
            slug
            image
            price
            discount
            finalPrice
            capacity
            isDownloadable
            rate
            createdAt
            updatedAt
        }
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  orderDocumentPayment: async (id) => {
    let Query = {
      query: `
   mutation {
    orderDocumentPayment(id: ${JSON.stringify(id)}, 
    device: 2 ,
    redirect: ${JSON.stringify(Redirect + '/callbackDocument')}){
        url
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  product: async (id) => {
    let Query = {
      query: `
   query {
    product(id: ${JSON.stringify(id)}){
        _id
        category {
            title
            slug
        }
        title
        slug
        image
        price
        like
        countLike
        discount
        finalPrice
        capacity
        isDownloadable
        rate
        pdf
        createdAt
        updatedAt
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  addCart: async (id, count) => {
    let Query = {
      query: `
   mutation {
    basketAdd(
        product: ${JSON.stringify(id)},
        count: ${count}
    ){
        count
        product {
            _id
        }
        
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  basket: async () => {
    let Query = {
      query: `
   query {
    basket{
        count
        product {
            _id
            category {
                title
                slug
            }
            title
            image
            price
            discount
            finalPrice
            isDownloadable
        }
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  basketRemove: async (id) => {
    let Query = {
      query: `
   mutation {
    basketRemove(
        product: ${JSON.stringify(id)}
    ){
        count
        product {
            _id
        }
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  orderShop: async (inputs, typeSendId) => {
    let Query = {
      query: `
  mutation {
    order(input: {
        address: ${JSON.stringify(inputs.address)},
        mobile: ${JSON.stringify(inputs.mobile)},
        postcode: ${JSON.stringify(inputs.postcode)},
        province: ${JSON.stringify(inputs.province)},
        city: ${JSON.stringify(inputs.city)},
        send: ${JSON.stringify(typeSendId)},
        device: 2,
        redirect: ${JSON.stringify(Redirect + '/callbackShop')}
    }){
        url
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  orderShopDownload: async (mobile) => {
    let Query = {
      query: `
  mutation {
    orderDownloadable(input: {
        mobile: ${JSON.stringify(mobile)},
        device: 2,
        redirect: ${JSON.stringify(Redirect + '/callbackShop')}
        }){
        url
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  sends: async () => {
    let Query = {
      query: `
  query {
    sends{
        _id
        title
        icon
        price
        free
        createdAt
        updatedAt
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  likeDislikeProduct: async (id) => {
    let Query = {
      query: `
 mutation {
    productLike(product: ${JSON.stringify(id)}){
        message
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  rateLiProduct: async (id, rate) => {
    let Query = {
      query: `
 mutation {
    productRate(product: ${JSON.stringify(id)}, rate: ${rate}){
        _id
        category {
            title
            slug
        }
        title
        slug
        image
        price
        discount
        finalPrice
        capacity
        isDownloadable
        rate
        createdAt
        updatedAt
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },

  documentPayment: async (id) => {
    let Query = {
      query: `
query {
    documentPayment(id: ${JSON.stringify(id)}){
        _id
        document {
          _id
            title
            number
        }
        lawyer {
            title
            fname
            lname
        }
        amount
        status
        afterSessionCourt
        afterSessionOnlin
        ref
        ip
        device
        createdAt
        updatedAt
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  orderList: async (page) => {
    let Query = {
      query: `
query {
    orderList(page: ${page}, limit: 10){
        currentPage
        totalPages
        data{ 
            _id
            user{
                fname
                lname
                mobile
            }
            province {
                title
            }
            city {
                title
            }
            send {
                title
            }
            refid
            trackingCode
            amount
            postcode
            mobile
            products {
                product {
                   _id
                    title
                    slug
                     image
                }
                price
                count
                discount
                finalPrice
            }
            device
            statusPayment
            status
            createdAt
            updatedAt
        }
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },

  orderSingle: async (id) => {
    let Query = {
      query: `
query {
    orderSingle(order: ${JSON.stringify(id)}){
        _id
        user{
            fname
            lname
            mobile
        }
        province {
            title
        }
        city {
            title
        }
        send {
            title
        }
        refid
        trackingCode
        amount
        postcode
        mobile
        products {
            product {
                _id
                title
                slug
                isDownloadable
                pdf
                image
            }
            price
            count
            discount
            finalPrice
        }
        device
        statusPayment #STATUS_PAYMENT_FAILED = 1,  STATUS_PAYMENT_SUCCESS = 2
        status #STATUS_PROCESS = 1, STATUS_SENT = 2, STATUS_CANCELED = 3
        createdAt
        updatedAt
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
  orderGift: async (id, inputs, typeSendId) => {
    let Query = {
      query: `
mutation {
    orderGift(input: {
        product: ${JSON.stringify(id)},
        count:${inputs.count},
        address: ${JSON.stringify(inputs.address)},
        mobile: ${JSON.stringify(inputs.mobile)},
        postcode: ${JSON.stringify(inputs.postcode)},
        province: ${JSON.stringify(inputs.province)},
        city: ${JSON.stringify(inputs.city)},
        send: ${JSON.stringify(typeSendId)},
        email:${JSON.stringify(inputs.email)}
        device: 2
    }){
        url
    }
}
      `,
    }
    return await axios.post(`${ApiUrl}`, Query, {
      headers: {
        Authorization: `Bearer ${GetTokenWithExpiry('token')}`,
      },
    })
  },
}
